<section id="cambiar-contrasena" class="auth-flow auth-flow--session">
  <microempresario-header></microempresario-header>

  <main class="auth-flow__main">
    <div class="auth-flow__panel">
      <h1 class="auth-flow__title">Cambiar contraseña</h1>

      <form class="auth-flow__form" [formGroup]="cambioContraForm" (ngSubmit)="validateForm()" novalidate>
        <div class="auth-flow__field" [class.auth-flow__field--invalid]="validateField('contraActual')">
          <label class="auth-flow__label" for="contraActual">Contraseña actual*</label>
          <div class="auth-flow__password">
            <input id="contraActual" class="auth-flow__control" maxlength="20" formControlName="contraActual"
              [type]="isVisible ? 'text' : 'password'" autocomplete="current-password"
              [class.is-invalid]="validateField('contraActual')" />
            <button class="auth-flow__password-toggle" type="button" (click)="showPassword()"
              [attr.aria-label]="isVisible ? 'Ocultar contraseña' : 'Mostrar contraseña'">
              <span [class]="isVisible ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
            </button>
          </div>
          <div class="auth-flow__error">
            Campo obligatorio (Debe tener como mínimo 8 caracteres, 1 mayúscula, 1 minúscula, 1 número y 1 caracter
            especial (&#64;$+#!%*?&-/_.,))
          </div>
        </div>

        <div class="auth-flow__field" [class.auth-flow__field--invalid]="validateField('contraNueva')">
          <label class="auth-flow__label" for="contraNueva">Contraseña nueva*</label>
          <div class="auth-flow__password">
            <input id="contraNueva" class="auth-flow__control" maxlength="20" formControlName="contraNueva"
              [type]="isVisibleNueva ? 'text' : 'password'" autocomplete="new-password"
              [class.is-invalid]="validateField('contraNueva')" />
            <button class="auth-flow__password-toggle" type="button" (click)="showPasswordNueva()"
              [attr.aria-label]="isVisibleNueva ? 'Ocultar contraseña' : 'Mostrar contraseña'">
              <span [class]="isVisibleNueva ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
            </button>
          </div>
          <div class="auth-flow__error">
            Campo obligatorio (Debe tener como mínimo 8 caracteres, 1 mayúscula, 1 minúscula, 1 número y 1 caracter
            especial (&#64;$+#!%*?&-/_.,))
          </div>
          @if (cambioContraForm.controls.contraNueva.hasError('repeatPass')) {
          <div class="auth-flow__error auth-flow__error--block">La contraseña debe ser diferente a la actual</div>
          }
        </div>

        <div class="auth-flow__field" [class.auth-flow__field--invalid]="validateField('confirContraNueva')">
          <label class="auth-flow__label" for="confirContraNueva">Confirme contraseña nueva*</label>
          <div class="auth-flow__password">
            <input id="confirContraNueva" class="auth-flow__control" maxlength="20"
              formControlName="confirContraNueva" [type]="isConfirm ? 'text' : 'password'"
              autocomplete="new-password" [class.is-invalid]="validateField('confirContraNueva')" />
            <button class="auth-flow__password-toggle" type="button" (click)="showConfirmPassword()"
              [attr.aria-label]="isConfirm ? 'Ocultar contraseña' : 'Mostrar contraseña'">
              <span [class]="isConfirm ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
            </button>
          </div>
          @if (cambioContraForm.controls.confirContraNueva.hasError('confirmPasswordMatch')) {
          <div class="auth-flow__error auth-flow__error--block">Las contraseñas no coinciden</div>
          }
        </div>

        <div class="auth-flow__actions">
          <a class="auth-flow__btn auth-flow__btn--secondary" id="btn-cambiar-contrasena-volver"
            routerLink="/microempresario/home" (click)="trackVolver()">Volver</a>
          <button type="submit" class="auth-flow__btn auth-flow__btn--primary" id="btn-cambiar-contrasena-guardar"
            [disabled]="isLoading">
            @if (isLoading) {
            <span class="spinner-grow spinner-grow-sm text-light" role="status" aria-hidden="true"></span>
            <span class="visually-hidden">Guardando…</span>
            } @else {
            Guardar
            }
          </button>
        </div>
      </form>
    </div>
  </main>

  <app-home-site-footer></app-home-site-footer>

  <div class="modal fade text-center" id="mensajeModal" tabindex="-1" aria-labelledby="mensajeModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <h2 class="auth-flow__modal-title">La contraseña ha sido actualizada exitosamente</h2>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" class="auth-flow__btn auth-flow__btn--primary" data-bs-dismiss="modal"
            routerLink="/microempresario/home">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
